export default __webpack_public_path__ + "static/media/play.371190b4.svg";